import React from 'react';
import classNames from 'classnames';

const Alert = ({type, children}) => (
    <div className={classNames('alert', {
        'alert-warning': type === 'warning',
        'alert-danger': type === 'danger',
    })} role="alert">
        <div className="container">
            {children}
            {/* <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>*/}
        </div>
    </div>
);

export default Alert;
